<div class="d-flex flex-row">
  @if (start && end) {
    <p-floatlabel class="flex-grow-1">
        <p-date-picker
          [id]="'date-range-filter-element-' + inputId"
          [(ngModel)]="value"
          selectionMode="range"
          (onSelect)="onFilterChange(value)"
          (onClear)="onFilterChange([])"
          [showClear]="true"
          [showButtonBar]="true"
          class="d-flex"
        ></p-date-picker>
        @if(label) {
          <label [for]="'date-range-start-filter-element-' + inputId">{{label | translate}} {{'rangeDate' | translate}}</label>
        } @else {
          <label [for]="'date-range-start-filter-element-' + inputId">{{ 'rangeDate' | translate }}</label>
        }
      </p-floatlabel>
  } @else {
    @if(start) {
      <p-floatlabel>
        <p-date-picker
          [id]="'date-range-start-filter-element-' + inputId"
          [(ngModel)]="value[0]"
          (onSelect)="onFilterChange(value)"
          (onClear)="onFilterChange([undefined, undefined])"
          [showClear]="true"
        ></p-date-picker>
        @if(label) {
          <label [for]="'date-range-start-filter-element-' + inputId">{{'startDate' | translate}} {{label | translate}}</label>
        } @else {
          <label [for]="'date-range-start-filter-element-' + inputId">{{ 'startDate' | translate }}</label>
        }
      </p-floatlabel>
    }
    @if (end) {
      <p-floatlabel>
        <p-date-picker
          [id]="'date-range-end-filter-element-' + inputId"
          [(ngModel)]="value[1]"
          (onSelect)="onFilterChange(value)"
          (onClear)="onFilterChange([undefined, undefined])"
          [showClear]="true"
        ></p-date-picker>
        @if(label) {
          <label [for]="'date-range-end-filter-element' + inputId">{{'endDate' | translate}} {{label | translate}}</label>
        } @else {
          <label [for]="'date-range-end-filter-element' + inputId">{{ 'endDate' | translate }}</label>
        }
      </p-floatlabel>
    }
  }
</div>